import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { SafeValue } from "@angular/platform-browser";
import { GetGameRulesUseCase } from "./domain/get-game-rules.use-case";
import { GetConfigUseCase } from "../core/config/get-config.use-case";
import { ILobbyConfig } from "../core/config/interfaces";
import { BalancePipe, FormatNumberPipe } from "@karma-games/angular-devkit/src/lib/modules/pipes";

@Component({
    selector: "game-rules",
    templateUrl: "./game-rules.component.html",
    styleUrls: ["./game-rules.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class GameRulesComponent implements OnInit {
    public rules: SafeValue | string = "";

    constructor(private getGameRulesUseCase: GetGameRulesUseCase,
                private getConfigUseCase: GetConfigUseCase,
                private balancePipe: BalancePipe,
                private formatNumberPipe: FormatNumberPipe,
                private cdr: ChangeDetectorRef) {
    }

    async ngOnInit(): Promise<void> {
        this.rules = await this.getGameRulesUseCase.execute();
        const config: ILobbyConfig | undefined = await this.getConfigUseCase.execute();
        const maxWinAmount: string = this.balancePipe.transform(config?.maxWinAmount ?? 0, true, true);
        const maxMultiplier: string = this.formatNumberPipe.transform(config?.maxMultiplier ?? 20000, true);
        const minBet: string = this.balancePipe.transform(config?.minBet ?? 0.20, true, true);
        const maxBet: string = this.balancePipe.transform(config?.maxBet ?? 500, true, true);
        this.rules = (<string>this.rules).split("{maxMultiplier}").join(maxMultiplier);
        this.rules = (<string>this.rules).split("{maxWinAmount}").join(maxWinAmount);
        this.rules = (<string>this.rules).split("{minBet}").join(minBet);
        this.rules = (<string>this.rules).split("{maxBet}").join(maxBet);
        this.cdr.detectChanges();
    }
}
